import {Injectable} from '@angular/core';
import {Configurator} from '@spartacus/product-configurator/rulebased';
import {ConfigService, LocalStorageService} from '../../services';
import PriceSummaryDCP = Configurator.PriceSummaryDCP;
import Configuration = Configurator.Configuration;

export interface TotalValues {
  all?: string;
  editions_addons?: string;
  derivatives?: string;
}

const TERMS_GROUP_NAME: string = '_TERMS';
const DURATION_ATTRIBUTE_NAME: string = 'LIC_DURATION_SEL';

@Injectable({
  providedIn: 'root',
})
export class DcpConfiguratorPriceService {
  constructor(
    private localStorageService: LocalStorageService,
    private configService: ConfigService,
  ) {}

  public getInitialTotalValues(): TotalValues {
    return {all: '-', derivatives: '-', editions_addons: '-'};
  }

  public getTotalValues(priceSummaryDCP: PriceSummaryDCP): TotalValues {
    const totalValues = this.getInitialTotalValues();
    for (const subtotalGroup of priceSummaryDCP.subtotalGroups) {
      totalValues[subtotalGroup.code as keyof TotalValues] = subtotalGroup.formattedValues.totalValue;
    }
    return totalValues;
  }

  public getDcpSubtotalGroup(configuration: Configuration, code: string): Configurator.SubtotalGroup {
    return configuration.priceSummary?.priceSummaryDCP?.subtotalGroups.find(
      (group) => group.code === code,
    ) as Configurator.SubtotalGroup;
  }

  public getDuration(configuration: Configuration): number | null {
    const termsGroup = configuration.flatGroups.find((group) => (group.name?.indexOf(TERMS_GROUP_NAME) ?? 0) > 0);
    const durationAttribute = termsGroup?.attributes?.find((attr) => attr.name === DURATION_ATTRIBUTE_NAME);
    return durationAttribute ? Number(durationAttribute.selectedSingleValue) : null;
  }

  public isPartnerStore(): boolean {
    return this.configService.getString('consumerType') === 'ps';
  }

  public writePriceTooltipData(configuration: Configurator.Configuration) {
    const priceTooltipItems: any[] = [];
    configuration.priceSummary?.priceSummaryDCP?.items.forEach((item) => {
      priceTooltipItems.push({
        materialName: item?.['materialName'],
        netPriceDescription: item?.['formattedValues']?.netPriceDescription,
        totalValue: item?.['formattedValues']?.totalValue,
      });
    });
    this.localStorageService.setItem(configuration.productCode, JSON.stringify(priceTooltipItems));
  }
}
